export default __webpack_public_path__ + "static/media/946.130773a2.png";